import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static override targets = ['addon', 'showDetailsCTA', 'chevronIconDown', 'chevronIconUp']

  declare readonly addonTargets: HTMLElement[]
  declare readonly showDetailsCTATarget: HTMLElement
  declare readonly chevronIconDownTarget: HTMLElement
  declare readonly chevronIconUpTarget: HTMLElement

  handleShowDetailsClick() {
    if (this.showDetailsCTATarget.innerText === 'Show Details') {
      this.addonTargets?.map((t) => t.classList.remove('top-picks-card__details__addonsHide'))
      this.showDetailsCTATarget.textContent = 'Hide Details'
      this.chevronIconDownTarget.style.display = 'none'
      this.chevronIconUpTarget.style.display = 'block'
    } else {
      this.addonTargets?.map((t) => t.classList.add('top-picks-card__details__addonsHide'))
      this.showDetailsCTATarget.textContent = 'Show Details'
      this.chevronIconDownTarget.style.display = 'block'
      this.chevronIconUpTarget.style.display = 'none'
    }
  }
}
